







import React, { useState } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import WorkflowHostModal from './WorkflowHostModal';
import WorkflowMeasurementModal from './WorkflowMeasurementModal';
import WorkflowTriggerModal from './WorkflowTriggerModal'; // Importa el nuevo modal
import WorkflowContainer from './WorkflowContainer';
import ResourceItem from './ResourceItem';
import ModalAddHost from './ModalAddHost';
import ModalAddMedicion from '../Triggers/ModalAddMedicion';
import ModalAddTrigger from '../Triggers/ModalAddTrigger';
import ModalAddEvent from '../Triggers/ModalAddEvent';
import ModalAddNotificacion from '../Triggers/ModalAddNotificacion';
import ModalAddGroup from '../Triggers/ModalAddGroup';
import Modal from "react-modal";
import '../WorkFlow.css'
import { lang } from '../../generales/traduction';
import { capitalizeFirstLetter } from '../../../utils/utils';


const steps = [
  { id: 'host', label: 'Host' },
  { id: 'measurement', label: 'Measurement' },
  { id: 'trigger', label: 'Trigger' },
  { id: 'event', label: 'Event' },
  { id: 'notification', label: 'Notification' },
];

const AddHosModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "90%",
    padding: "20px",
  },
};
const AddMetricModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "30%",
    height: "70%",
    padding: "20px",
  },
};
const WorkflowApp = ({server,languaje,mode,hosts,setDataWorkFlow,dataWorkFlow}) => {
  const resources = [
    { id: 'host', label: capitalizeFirstLetter(lang[languaje]['dispositivo']), type: 'entity' },
    { id: 'group', label: capitalizeFirstLetter(lang[languaje]['grupo']), type: 'entity' },
    { id: 'measurement', label: capitalizeFirstLetter(lang[languaje]['metrica']), type: 'measurement' },
    { id: 'trigger', label: capitalizeFirstLetter(lang[languaje]['disparador']), type: 'trigger' },
    // { id: 'delay', label: 'Delay', type: 'delay' },
    { id: 'event', label: capitalizeFirstLetter(lang[languaje]['evento']), type: 'event' },
    { id: 'notification', label: capitalizeFirstLetter(lang[languaje]['notficacion']), type: 'notification' },
  ];
  const [orientation, setOrientation] = useState('vertical'); // 'vertical' | 'horizontal'
  const [enabledResources, setEnabledResources] = useState(['entity']);
  const [droppedItems, setDroppedItems] = useState([]);
  const [elementsList,SetElementList]=useState({
    host:'',
    measurement:'',
    trigger:'',
    event:'',
    notification:'',
    group:''
  })
  const [selectedItem, setSelectedItem] = useState(null);
  const [selections, setSelections] = useState({});
  const [isHostModalOpen, setIsHostModalOpen] = useState(false);
  const [isMeasurementModalOpen, setIsMeasurementModalOpen] = useState(false);
  const [isTriggerModalOpen, setIsTriggerModalOpen] = useState(false); // Estado para abrir el Trigger Modal
  const [addHostModalOpen, setAddHostModalOpen] = useState(false);
  function closeAddHostModal() {
    setAddHostModalOpen(false);
  }
  const [addGroupModalOpen, setAddGroupModalOpen] = useState(false);
  function closeAddGroupModal() {
    setAddGroupModalOpen(false);
  }
  const [addMetricModalOpen, setAddMetricModalOpen] = useState(false);
  function closeAddMetricModal() {
    setAddMetricModalOpen(false);
  }
  const [addTriggeModalOpen, setAddTriggeModalOpen] = useState(false);
  function closeAddTriggeModal() {
    setAddTriggeModalOpen(false);
  }
  const [addEventModalOpen, setAddEventModalOpen] = useState(false);
  function closeAddEventModal() {
    setAddEventModalOpen(false);
  }
  const [addNotiModalOpen, setAddNotiModalOpen] = useState(false);
  function closeAddNotiModal() {
    setAddNotiModalOpen(false);
  }
  const handleDrop = (item) => {
    let nextSteps = [];
    switch (item.type) {
      case 'entity':
        nextSteps = ['measurement'];
        if(item.id=="host"){
          setAddHostModalOpen(true);
        }else{
          setAddGroupModalOpen(true)
        }
        
        break;
      case 'measurement':
        nextSteps = ['trigger'];
        setAddMetricModalOpen(true);
        break;
      case 'trigger':
        nextSteps = ['event'];
        setAddTriggeModalOpen(true); // Abrir el Trigger Modal cuando se dropee un trigger
        break;
      // case 'delay':
      //   nextSteps = ['event'];
        // break;
      case 'event':
        nextSteps = ['notification'];
        setAddEventModalOpen(true)
        break;
      case 'notification':
        setAddNotiModalOpen(true)
        break;
      default:
        nextSteps = [];
    }
    setEnabledResources(nextSteps);
    setDroppedItems((prevItems) => [...prevItems, item]);
  };

  const handleHostSelect = (selectedOption) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      host: selectedOption,
    }));
    setIsHostModalOpen(false);
  };

  const handleMeasurementSelect = (selectedOption) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      measurement: selectedOption,
    }));
    setIsMeasurementModalOpen(false);
  };

  const handleTriggerSelect = (selectedOption) => {
    setSelections((prevSelections) => ({
      ...prevSelections,
      trigger: selectedOption,
    }));
    setIsTriggerModalOpen(false);
  };

  const handleRemoveItem = (item) => {
    if (droppedItems[droppedItems.length - 1].id === item.id) {
      setDroppedItems((prevItems) => prevItems.slice(0, -1));
      const previousSelections = { ...selections };
      delete previousSelections[item.id];
      setSelections(previousSelections);
      setEnabledResources([item.type]);
    }
    SetElementList((prevState)=>{
      return {
          ...prevState,
        [item.id]:""
      }
      
  })
    if(item.type=='notification'){
      setDataWorkFlow((prevState)=>{
        return {
            ...prevState,
          ['interested_user_group_ids']:[]
        }
        
    })
    setDataWorkFlow((prevState)=>{
      return {
          ...prevState,
        ['telegram_groups']:[]
      }
      
  })
    }
    else{
      
      if(item.id=='host'){
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['hostid']:null
          }
          
      })
      }else if(item.id=='group'){
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['groupid']:null
          }
          
      })
      }else{
        let attr=""
        if(item.type=='measurement'){
          attr="metric_id"
        }else if(item.type=='trigger'){
          attr='trigger_id'
        }else if(item.type='event'){
          attr='workflow_eventid'
        }
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            [attr]:0
          }
          
      })
      }
      
    }
  };

  const isLastItem = (item) => droppedItems.length > 0 && droppedItems[droppedItems.length - 1].id === item.id;

  const isStepCompleted = (stepId) => selections[stepId] !== undefined;

  const allStepsCompleted = steps.every((step) => isStepCompleted(step.id));

  return (
    <DndProvider backend={HTML5Backend}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        background: '#f8fafc',
        borderRadius: '12px',
        overflow: 'hidden',
        border: '1px solid #e2e8f0'
      }}>
        {/* NUEVO: Toggle de orientación (Vertical / Horizontal) */}
        <div style={{
          padding: '12px 20px',
          borderBottom: '1px solid #e2e8f0',
          background: '#ffffff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0f2d5e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
            </svg>
            <span style={{ fontSize: 13, fontWeight: 600, color: '#0f2d5e' }}>
              Flujo de trabajo
            </span>
            {/* contador de nodos */}
            <span style={{
              fontSize: 11, fontWeight: 600,
              padding: '2px 8px', borderRadius: 999,
              background: droppedItems.length > 0 ? '#e8f0fe' : '#f1f5f9',
              color: droppedItems.length > 0 ? '#1a56db' : '#64748b',
            }}>
              {droppedItems.length} {droppedItems.length === 1 ? 'paso' : 'pasos'}
            </span>
          </div>

          {/* Toggle de orientación */}
          <div style={{
            display: 'flex',
            background: '#f1f5f9',
            border: '1px solid #e2e8f0',
            borderRadius: 8,
            padding: 2,
            gap: 0,
          }}>
            {[
              { key: 'vertical', label: 'Vertical', icon: (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="12" y1="5" x2="12" y2="19" /><polyline points="19 12 12 19 5 12" />
                </svg>
              ) },
              { key: 'horizontal', label: 'Horizontal', icon: (
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12" /><polyline points="12 5 19 12 12 19" />
                </svg>
              ) },
            ].map(opt => {
              const active = orientation === opt.key;
              return (
                <button
                  key={opt.key}
                  onClick={() => setOrientation(opt.key)}
                  style={{
                    height: 28, padding: '0 12px',
                    borderRadius: 6, border: 'none',
                    background: active ? '#ffffff' : 'transparent',
                    color: active ? '#1a56db' : '#64748b',
                    fontSize: 12, fontWeight: 600,
                    cursor: 'pointer',
                    display: 'flex', alignItems: 'center', gap: 6,
                    boxShadow: active ? '0 1px 3px rgba(15,45,94,0.08)' : 'none',
                    transition: 'all 0.15s ease',
                  }}
                >
                  {opt.icon}
                  {opt.label}
                </button>
              );
            })}
          </div>
        </div>

        <div style={{
          display: 'flex',
          flex: 1,
          padding: '20px',
          gap: '20px',
          overflow: 'hidden'
        }}>
          {/* Panel de Recursos */}
          <div style={{
            width: '240px',
            background: '#ffffff',
            border: '1px solid #e2e8f0',
            borderRadius: '12px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            flexShrink: 0
          }}>
            <h3 style={{
              color: '#0f2d5e',
              fontWeight: 600,
              fontSize: '14px',
              marginBottom: '14px',
              textAlign: 'center',
              margin: 0
            }}>{capitalizeFirstLetter(lang[languaje]['recursos'])}</h3>
            {resources.map((resource) => (
              <ResourceItem
                key={resource.id}
                resource={resource}
                isDisabled={!enabledResources.includes(resource.type)}
              />
            ))}
          </div>

          {/* Canvas area */}
          <div style={{
            flex: 1,
            height: '100%',
            overflow: 'hidden'
          }}>
            <WorkflowContainer
              onDrop={handleDrop}
              acceptedTypes={enabledResources}
              droppedItems={droppedItems}
              onCardClick={setSelectedItem}
              onRemoveItem={handleRemoveItem}
              isLastItem={isLastItem}
              selections={selections}
              elementsList={elementsList}
              orientation={orientation}
            />
          </div>
        </div>


        {/* Tren de pasos */}
        {/* <div className='contSteps'>
          {steps.map((step) => (
            <div
              key={step.id}
              style={{
                padding: '10px 20px',
                borderRadius: '8px',
                backgroundColor: isStepCompleted(step.id) ? '#e0ffe0' : '#f0f0f0',
                border: `2px solid ${isStepCompleted(step.id) ? '#2ecc71' : 'gray'}`,
                color: isStepCompleted(step.id) ? '#2ecc71' : 'gray',
                fontWeight: 'bold',
                textAlign: 'center',
                minWidth: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {step.label}
            </div>
          ))}
        </div> */}

        {/* Botón para crear flujo de trabajo */}
        {/* <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
          <button
            onClick={() => console.log("Creando flujo de trabajo...")}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: allStepsCompleted ? 'blue' : 'gray',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: allStepsCompleted ? 'pointer' : 'not-allowed',
            }}
            disabled={!allStepsCompleted}
          >
            Crear flujo de trabajo
          </button>
        </div> */}
        {/* ********Modal host********* */}
        <Modal
        isOpen={addHostModalOpen}
        onRequestClose={closeAddHostModal}
        style={AddHosModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddHost
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeAddHostModal={closeAddHostModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddHost>
    </Modal>
      {/* ********Modal Group********* */}
      <Modal
        isOpen={addGroupModalOpen}
        onRequestClose={closeAddGroupModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddGroup
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal ={closeAddGroupModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddGroup>
    </Modal>
    {/******************ModalAddMedicion*******************  */}
    <Modal
        isOpen={addMetricModalOpen}
        onRequestClose={closeAddMetricModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddMedicion
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal={closeAddMetricModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddMedicion>
    </Modal>
 {/******************ModalAddTrigge*******************  */}
 <Modal
        isOpen={addTriggeModalOpen}
        onRequestClose={closeAddTriggeModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddTrigger
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal={closeAddTriggeModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddTrigger>
    </Modal>

{/******************ModalAddEvent*******************  */}
<Modal
        isOpen={addEventModalOpen}
        onRequestClose={closeAddEventModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddEvent
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal={closeAddEventModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddEvent>
    </Modal>
{/******************ModalAddNoti*******************  */}
<Modal
        isOpen={addNotiModalOpen}
        onRequestClose={closeAddNotiModal}
        style={AddMetricModalStyles}
        contentLabel="Example Modal2"
        shouldCloseOnOverlayClick={false}
      >
      <ModalAddNotificacion
      hosts={hosts} 
      server={server}
      languaje={languaje}
      mode={mode}
      setDataWorkFlow={setDataWorkFlow}
      dataWorkFlow={dataWorkFlow}
      closeModal={closeAddNotiModal}
      SetElementList={SetElementList}
      elementsList={elementsList}
      handleRemoveItem={handleRemoveItem}
    ></ModalAddNotificacion>
    </Modal>










        {/* Modales */}
        <WorkflowHostModal
        server={server}
          isOpen={false}
          onRequestClose={() => {
            setIsHostModalOpen(false);
          }}
          onSelect={handleHostSelect}
        />

        <WorkflowMeasurementModal
          isOpen={isMeasurementModalOpen}
          onRequestClose={() => {
            setIsMeasurementModalOpen(false);
          }}
          onSelect={handleMeasurementSelect}
          hostId={selections.host?.id}
        />

        <WorkflowTriggerModal
          isOpen={isTriggerModalOpen}
          onRequestClose={() => {
            setIsTriggerModalOpen(false);
          }}
          onSelect={handleTriggerSelect}
          metricId={selections.measurement?.id} // Pasa el ID de la métrica seleccionada
        />
      </div>
    </DndProvider>
  );
};

export default WorkflowApp;
